import { PageMainCard } from '..';
import { MdError } from 'react-icons/md';

const NoVehicleIdCard = () => {
    return (
        <PageMainCard>
            <div className="flex justify-center flex-wrap">
                <div className="flex w-full justify-center text-2xl text-red-600 items-center mb-4">
                    <MdError color="red" size={60} className="mr-2" />
                    Oh no! An error has occurred!
                </div>
                <h4 className="flex text-xl text-gray-500 items-center mb-4">
                    Please come back soon...
                </h4>
            </div>
        </PageMainCard>
    );
};

export default NoVehicleIdCard;
